import moment from "moment";

moment.updateLocale("es", {
  week: {
    dow: 1,
    doy: 6
  }
});
